import React, { useRef } from 'react';
import ExternalLink from 'components/Widgets/ExternalLink';

import iconAppleStore from 'images/new_ui/apple-store-badge.png';
import iconGooglePlay from 'images/new_ui/google-play-badge.png';

import useSize from 'components/Common/Screen/Hooks/useSize';

export default function MobileAppInfo() {
  const wrapper = useRef(null);
  const size = useSize(wrapper);

  console.log(size);

  return (
    <div className="mt-4">
      <h4>Install Mobile App</h4>
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          <p>
            LeggUP members can install our app now!
            Download the app and use your LeggUP username and password to login.
            You can schedule your sessions, meet with your coach and get access to all
            session articles included with your program in one single app.
          </p>
        </div>
        <div ref={wrapper} className="col-lg-6 mt-2">
          <div
            style={{ flexDirection: (size && size.width > 430 ? 'row' : 'column') }}
            className=" d-flex justify-content-end gap-2"
          >
            <div className="d-flex justify-content-end">
              <ExternalLink
                variant="link"
                href="https://apps.apple.com/us/app/leggup/id1582610227"
              >
                <img src={iconAppleStore} alt="apple store" width="200px" />
              </ExternalLink>
            </div>
            <div className="d-flex justify-content-end">
              <ExternalLink
                variant="link"
                href="https://play.google.com/store/apps/details?id=com.leggup.mobile"
              >
                <img src={iconGooglePlay} alt="google play" width="200px" />
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
